
import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer, Legend, Tooltip } from 'recharts';
import { Card } from '@/components/ui/card';
import { ChartContainer, ChartTooltipContent } from '@/components/ui/chart';

const COLORS = ['#93c5fd', '#4ade80', '#f472b6', '#fbbf24'];

interface ReferralSourceData {
  name: string;
  value: number;
}

interface ReferralSourcePieChartProps {
  data: ReferralSourceData[];
}

const ReferralSourcePieChart: React.FC<ReferralSourcePieChartProps> = ({ data }) => {
  return (
    <Card className="p-8 h-full">
      <div className="flex flex-col items-center justify-center h-full space-y-6">
        <h3 className="text-xl font-semibold text-gray-900">Referral Sources</h3>
        
        <div className="w-full h-[350px] flex items-center justify-center">
          <ChartContainer 
            config={{
              email: { color: "#93c5fd" },
              social: { color: "#4ade80" },
              direct: { color: "#f472b6" },
              other: { color: "#fbbf24" }
            }}
            className="w-full max-w-[500px]"
          >
            <ResponsiveContainer width="100%" height="100%">
              <PieChart>
                <Pie
                  data={data}
                  cx="50%"
                  cy="45%"
                  outerRadius={120}
                  innerRadius={60}
                  dataKey="value"
                  label={({name, percent}) => `${name} ${(percent * 100).toFixed(0)}%`}
                  labelLine={false}
                >
                  {data.map((entry, index) => (
                    <Cell 
                      key={`cell-${index}`} 
                      fill={COLORS[index % COLORS.length]}
                      stroke="white"
                      strokeWidth={2}
                    />
                  ))}
                </Pie>
                <Tooltip content={<ChartTooltipContent />} />
                <Legend 
                  verticalAlign="bottom"
                  height={36}
                  wrapperStyle={{
                    paddingTop: "24px",
                    marginBottom: "-20px",
                    width: "100%",
                    display: "flex",
                    justifyContent: "center"
                  }}
                />
              </PieChart>
            </ResponsiveContainer>
          </ChartContainer>
        </div>
      </div>
    </Card>
  );
};

export default ReferralSourcePieChart;
